import React, { Component } from 'react';
import Page from './Page';
import Image from './Image';

class StatusPage extends Component {
    render = () => (
        <Page className={'statusPage'}>
            <div className={'purple-bar'}>
                <Image className={'homeIcon'} cloudinaryCrop={'fill'} src={'/static/images/logo.svg'} />
            </div>
            <div className={'container'}>
                <h1 className={'verb-title-1'}>Oops!</h1>
                <div className={'error-text'}>Something went wrong...</div>
            </div>
        </Page>
    );
}

export default StatusPage;
